import React from "react";
import "./howdoesitwork.css";

import step1Img from "./images/hdiw1.webp";
import step2Img from "./images/hdiw2.webp";
import step3Img from "./images/hdit3.webp";

const steps = [
  {
    id: 1,
    title: "Find Your Equipment",
    description:
      "Browse our wide range of construction equipment available for rent or purchase. Easily explore products that match your project requirements.",
    image: step1Img,
  },
  {
    id: 2,
    title: "Order It Online",
    description:
      "Submit your order online and our team will verify availability, pricing, and delivery details for a smooth experience.",
    image: step2Img,
  },
  {
    id: 3,
    title: "Get It Delivered",
    description:
      "We ship the equipment directly to your location, ready for immediate use and backed by reliable support.",
    image: step3Img,
  },
];

const HowItWorks = () => {
  return (
    <section className="how-it-works">
      <div className="how-it-works-header">
        <h2 className="section-title">HOW DOES IT WORK</h2>

        <p className="section-subtitle">
          Simple process to rent or purchase construction equipment across USA.
        </p>
      </div>

      <div className="timeline-wrapper">
        {steps.map((step, index) => (
          <div
            className={`timeline-step ${index % 2 === 0 ? "left-layout" : "right-layout"
              }`}
            key={step.id}
          >
            <div className="timeline-image-section">
              <img
                src={step.image}
                alt={step.title}
                className="timeline-image"
              />
            </div>

            <div className="timeline-line">
              <div className="timeline-dot">{step.id}</div>
            </div>

            <div className="timeline-content-section">
              <h3>{step.title}</h3>

              <p>{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;